import { useGetMentorsByCoursesCanTeach } from '@actions';
import Modal from '@components/V4/Modal/Modal';
import { PaginationProps } from '@components/V4/Pagination';
import DetailsModal from '@modules/Admin/components/DetailsModal/DetailsModal';
import { UserRole } from '@shared/enums';
import { useState } from 'react';
import ProfilesModalTable from '../ProfilesModalTable';

interface MentorsCoursesProps {
  courseCanTeach: string;
  title?: string;
}

const MentorsCoursesCanTeach = (props: MentorsCoursesProps) => {
  const { courseCanTeach, title } = props;
  const [limit, setLimit] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);

  const { data: mentorsByCoursesCanTeach, isLoading: areMentorsLoading } =
    useGetMentorsByCoursesCanTeach({
      limit,
      page,
      sortBy,
      sortOrder,
      courseCanTeach,
    });
  const usersList = mentorsByCoursesCanTeach?.users;
  const [userId, setUserId] = useState<string>();
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const currentPageChangeHandler = (page: number) => {
    setPage(page);
  };

  const pageSizeChangeHandler = (size: number) => {
    setLimit(size);
  };

  const userModalOpenHandler = (userId: string) => {
    setUserId(userId);
    setShowDetailsModal(true);
  };
  const closeSessionModalHandler = () => {
    setShowDetailsModal(false);
  };
  const pagination: PaginationProps = {
    pageSize: limit || 10,
    total: mentorsByCoursesCanTeach ? mentorsByCoursesCanTeach.total : 0,
    currentPage: page || 1,
    onCurrentPageChange: currentPageChangeHandler,
    onPageSizeChange: pageSizeChangeHandler,
  };

  return (
    <>
      <Modal.Header title={`Mentors that can teach ${title}`} />
      <Modal.Body>
        <ProfilesModalTable
          usersList={usersList || []}
          areUsersLoading={areMentorsLoading}
          pagination={pagination}
          userModalOpenHandler={userModalOpenHandler}
          role={UserRole.Mentor}
        />
      </Modal.Body>
      {showDetailsModal && (
        <DetailsModal
          page={'mentor'}
          isOpen={true}
          onClose={closeSessionModalHandler}
          mentorId={userId}
        />
      )}
    </>
  );
};

export default MentorsCoursesCanTeach;
